/**
 * Returns whether an object is undefined or null
 * @param   x
 * @return {Boolean}
 */
export default function isNullOrUndefined(x) {
  return typeof x === 'undefined' || x === null;
}
